import {
  parseAsArrayOf,
  parseAsIsoDate,
  parseAsJson,
  parseAsString,
} from "nuqs/server";
import { z } from "zod";

export const tourSearchParams = {
  date: parseAsIsoDate,
  locations: parseAsArrayOf(parseAsString).withDefault([]),
  query: parseAsString.withDefault(""),
  page: parseAsJson(z.number().int().min(1).catch(1).parse).withDefault(1),
};
